export default __webpack_public_path__ + "static/media/img1.c1591fdc.JPG";